import { render } from "./pri.vue?vue&type=template&id=5da14d86"
import script from "./pri.vue?vue&type=script&lang=js"
export * from "./pri.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__